import { CreatePartnerNewsRequestSchema, CreatePartnerNewsResponseSchema } from './create-partner-news.schema';
export const createPartnerNewsContract = {
    method: 'POST',
    path: '/api/v2/admin/partner-news',
    description: 'Create a partner news entry',
    requestSchema: CreatePartnerNewsRequestSchema,
    responseSchema: CreatePartnerNewsResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            400: 'Bad Request - invalid input data',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - superadmin only'
        }
    }
};

//# sourceMappingURL=create-partner-news.contract.js.map